import CreatableSelect from 'react-select/creatable';
import { Controller } from 'react-hook-form';

const DropdownWithText = ({
    onChange = null,
    options = [],
    placeholder = null,
    value,
    field,
    isLoading,
    noOptionsMessage,
    isDisabled = false,
}) => {

    return (
            <CreatableSelect
                {...field}
                options={options}
                isClearable
                onChange={onChange}
                value={value}
                isLoading={isLoading}
                noOptionsMessage={noOptionsMessage}
                isDisabled={isDisabled}
                rules={{ required: "This field is required" }}
                placeholder={placeholder || 'Select / Type'}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                styles={{
                        control: (provided) => ({
                                 ...provided,
                                  minHeight: "50px",
                                  borderRadius: "8px",
                                  borderColor: "#CBD5E0",
                                }),
                        singleValue: (provided) => ({
                                  ...provided,
                                  whiteSpace: 'normal', // Allows text to wrap inside the box
                                  overflow: 'visible',  // Allows longer text to be displayed
                                  textOverflow: 'unset', // Prevents ellipsis ('...') from appearing
                                }),
                        container: (provided) => ({
                                    ...provided,
                                    width: '95%', // or '100%', 'auto', etc.
                                    marginRight: '30px'
                                  }),
                        menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999, // ensures dropdown is above modal/scroll
                        }),
                        menu: (provided) => ({
                            ...provided,
                            zIndex: 9999
                        })
                        }}
        />
    )
};

export default DropdownWithText;